// extracted by mini-css-extract-plugin
module.exports = {"seoText":"SEO_seoText__S_Lp5"};